import API from "../../api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async getCouponByName({ commit }, text_search) {
      try {
        return await API.Coupons.getCouponByName(text_search);
      } catch (error) {
        throw error;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/coupons.js